var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLand(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.733,
    height: 28.173,
    viewBox: "0 0 30.733 28.173",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Component 40 \\u2013 1"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 8686"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 29072",
    d: "M5.123 3.926a.639.639 0 0 1-.489-.226L2.881 1.631 1.129 3.7a.64.64 0 1 1-.977-.828L2.393.226a.64.64 0 0 1 .977 0l2.241 2.646a.64.64 0 0 1-.488 1.054z",
    transform: "rotate(180 2.881 14.086)",
    style: {
      fill: "gray"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 29073",
    d: "M2.881 3.926a.64.64 0 0 1-.488-.226L.152 1.054a.64.64 0 1 1 .977-.828L2.881 2.3 4.634.226a.64.64 0 1 1 .977.828L3.37 3.7a.64.64 0 0 1-.489.226z",
    transform: "rotate(180 2.881 3.883)",
    style: {
      fill: "gray"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 26",
    d: "M.64 23.05a.64.64 0 0 1-.64-.64V.64a.64.64 0 0 1 1.281 0v21.77a.64.64 0 0 1-.641.64z",
    transform: "rotate(180 1.76 13.833)",
    style: {
      fill: "gray"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Component 40 \\u2013 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 8686"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 29072",
    d: "M3.5 2.566a.5.5 0 0 1-.382-.177L1.75.774.382 2.389a.5.5 0 0 1-.7.058.5.5 0 0 1-.058-.7l1.744-2.07A.5.5 0 0 1 1.75-.5a.5.5 0 0 1 .382.177l1.75 2.066a.5.5 0 0 1-.381.823z",
    style: {
      fill: "gray"
    },
    transform: "rotate(-90 8.117 -4.116)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 29073",
    d: "M1.75 2.566a.5.5 0 0 1-.382-.177L-.382.323a.5.5 0 0 1 .058-.7.5.5 0 0 1 .7.058L1.75 1.292 3.118-.323a.5.5 0 0 1 .7-.058.5.5 0 0 1 .058.7l-1.744 2.07a.5.5 0 0 1-.382.177z",
    transform: "matrix(0 -1 1 0 28.167 4)",
    style: {
      fill: "gray"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 26",
    d: "M0 17.5a.5.5 0 0 1-.5-.5V0A.5.5 0 0 1 0-.5a.5.5 0 0 1 .5.5v17a.5.5 0 0 1-.5.5z",
    transform: "rotate(-90 7.438 -5.19)",
    style: {
      fill: "gray"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 8687"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Path 29102",
    style: {
      strokeLinejoin: "round",
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-.231 0h3.074a.747.747 0 0 1 .769.724v2.962L-1 7.683V.724A.747.747 0 0 1-.231 0z",
    style: {
      stroke: "none"
    },
    transform: "translate(8.677 10.882)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 1v4.493L2.612 3.23V1H0m-.231-1h3.074c.425 0 .769.324.769.724v2.962L-1 7.683V.723C-1 .325-.656 0-.231 0z",
    style: {
      fill: "gray",
      stroke: "none"
    },
    transform: "translate(8.677 10.882)"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 29100",
    d: "M33.026 474.327a.624.624 0 0 1-.424-.167l-7.908-7.3-7.908 7.3a.624.624 0 0 1-.891-.043.647.647 0 0 1 .042-.9l8.333-7.687a.624.624 0 0 1 .849 0l8.333 7.687a.647.647 0 0 1 .042.9.625.625 0 0 1-.468.21z",
    transform: "translate(-9.967 -454.477)",
    style: {
      fill: "gray"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 29101",
    d: "M31.586 480.056H17.5v-11.525h1.328v10.3h11.43v-9.723h1.328z",
    transform: "translate(-9.817 -451.885)",
    style: {
      fill: "gray"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 18062",
    style: {
      stroke: "gray",
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 0h4.149a1 1 0 0 1 1 1v6.687H0V1a1 1 0 0 1 1-1z",
    style: {
      stroke: "none"
    },
    transform: "translate(11.518 20.485)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 .5h4.149a.5.5 0 0 1 .5.5v6.187H.5V1A.5.5 0 0 1 1 .5z",
    style: {
      fill: "none"
    },
    transform: "translate(11.518 20.485)"
  }))), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 29098",
    d: "M3.2 307.2c-3.165 0-3.2 8.058-3.2 8.139a3.154 3.154 0 0 0 2.561 3.067v2.879h1.281v-2.879a3.154 3.154 0 0 0 2.558-3.067c0-.081-.034-8.139-3.2-8.139zm0 10.018a1.9 1.9 0 0 1-1.921-1.878c0-3.119.857-6.887 1.921-6.887s1.921 3.768 1.921 6.887a1.9 1.9 0 0 1-1.921 1.878z",
    transform: "translate(24.33 -293.113)",
    style: {
      fill: "gray"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 18073",
    width: 24.971,
    height: 1.281,
    rx: 0.64,
    transform: "translate(5.762 26.891)",
    style: {
      fill: "gray"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLand);
export default __webpack_public_path__ + "static/media/land.32d4e93ef65ac00355535bf1238c0ce6.svg";
export { ForwardRef as ReactComponent };